import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import BookReader from "./components/BookReader";
import AdminLeads from "./components/AdminLeads";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<BookReader />} />
                    <Route path="/admin/leads" element={<AdminLeads />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
